import React from 'react';
import { Anchor } from 'antd';

const { Link } = Anchor;

function Header() {
  return (
    <header className="header">
      <div className="container">
        <div className="clearfix">
          <div className="pull-left">
            <h1 className="brand">Samran</h1>
          </div>
          <div className="pull-right">
            <Anchor className="main-menu" bounds={75}>
              <Link className="menu-item" href="#home" title="About" />
              <Link className="menu-item" href="#service_section" title="Service" />
              <Link className="menu-item" href="#portfolio_section" title="Portfolio" />
              <Link className="menu-item" href="#contact_section" title="Contact" />
            </Anchor>
          </div>
        </div>
        <hr className="divider" />
      </div> 
    </header>
  );
}

export default Header;
